import React from 'react'
import { Redirect } from 'common-tools/ReachRouter'
import { sh, ReduxWrapper, compose } from 'common-data/datahelpers'
import Loadable from 'react-loadable'
import { LoadableLoading } from 'common-controls/App/LoadableLoading'
// import App from 'common-views/App/App'

const App = Loadable({
  loader: () => import('common-views/App/App'),
  loading: (props) => {
    return <LoadableLoading {...props} />
  }
})

class AppRoutePlain extends React.Component {
  render () {
    const { SessionToken, location } = this.props

    if (!SessionToken) {
      return <Redirect from='/App' to={`/Login?returnURL=${location ? location.pathname : ''}`} />
    }

    return React.createElement(App, this.props)
  }
}

export const AppRoute = compose(
  ReduxWrapper([
    sh.SessionToken
  ])
)(AppRoutePlain)
